import { getCommercialOffers } from '@/redux/operation/operationsAPI';
import { FlowCommercialOffer } from '@/redux/operation/operationsInterface';

export const retrieveCommercialOffers = async (): Promise<
FlowCommercialOffer[] | null
> => {
  try {
    const response = await getCommercialOffers();
    return response.data.flow_commercial_offers;
  } catch (error) {
    return null;
  }
};



export const checkCommercialOfferAvailabilityECO = async (
  totalPrice: number
): Promise<boolean> => {
  const offerS = sessionStorage.getItem('pepper-commercial-offers-S');
  let commercialOffers;

  // Comprobamos si ya tenemos las ofertas comerciales en el sessionStorage
  if (!offerS) {
    // Si no las tenemos, las recuperamos
    commercialOffers = await retrieveCommercialOffers();
    if (commercialOffers) {
      sessionStorage.setItem(
        'pepper-commercial-offers-S',
        JSON.stringify(commercialOffers)
      );
    }
  } else {
    // Esto es lo que se guarda en el sessionStorage y se recupera
    commercialOffers = JSON.parse(offerS);
  }

  // Comprobamos si hay ofertas comerciales
  if (commercialOffers) {
    // Recorremos las ofertas comerciales para poder filtrar por el flujo ECO
    for (const offer of commercialOffers) {
      if (offer.flow === 'ECO') {
        // Comprobamos si el importe total del pedido está dentro del rango de financiación
        const minAvailability: number = Math.min(
          ...offer.commercial_offers.map(
            (commercial_offer: any) => commercial_offer.min_amount
          )
        );
        const maxAvailability: number = Math.max(
          ...offer.commercial_offers.map(
            (commercial_offer: any) => commercial_offer.max_amount
          )
        );
        if (minAvailability > totalPrice || maxAvailability < totalPrice) {
          return false;
        }
      }
    }
  }

  return true;
};